export enum OPERATION_DETAILS_EVENT_TYPE {
  'USER_INPUT' = 'USER_INPUT',
  'SPECIAL_EVENT' = 'SPECIAL_EVENT',
  'USSD_APP_RESPONSE' = 'USSD_APP_RESPONSE'
}
interface UssdInputEvent {
  date: string;
  type: OPERATION_DETAILS_EVENT_TYPE.USER_INPUT;
  input: string;
}

interface SpecialEvent {
  date: string;
  type: OPERATION_DETAILS_EVENT_TYPE.SPECIAL_EVENT;
  text: string;
}

interface UssdAppResponseEvent {
  date: string;
  type: OPERATION_DETAILS_EVENT_TYPE.USSD_APP_RESPONSE;
  response: string;
}

export type EventItem = UssdInputEvent | SpecialEvent | UssdAppResponseEvent;

export interface PresentEventsType {
  type: 'PRESENT';
  items: EventItem[];
}

export interface ExpiredEventsType {
  type: 'EXPIRED';
  message: string;
}

export type EventsType = PresentEventsType | ExpiredEventsType;
